class LightBoxVideo {
    constructor() {
        this.videos = {};
        this.lightBoxVideo();
    }

    lightBoxVideo = () => {
        this.setEvents();
        this.setMutationObserver();
    }

    setMutationObserver = () => {
        const observer = new MutationObserver(mutation => {
            const imageMutations = mutation.filter((m) => {
                return m.attributeName === "src" && m.target.className === 'lb-image'
            });

            const overlayDisplay = window.getComputedStyle(document.querySelector('.lightboxOverlay'), null).display;
            if("none" === overlayDisplay) {
                this.removeVideoElement();
            }

            if(imageMutations.length > 0) {
                if(this.videos[imageMutations[0].target.src]) {
                    this.removeVideoElement();
                    this.setVideoElement(this.videos[imageMutations[0].target.src]);
                }
            }
        });

        observer.observe(document.body, {
            childList: false,
            attributes: true,
            subtree: true,
            characterData: false
        });
    }

    setEvents = () => {
        const videoLinks = this.findVideoLinks();
        videoLinks.forEach((link) => {
            this.videos[link.href] = link;
            link.addEventListener('click', (e) => {
                this.removeVideoElement();
                this.setVideoElement(e.target);
            });
        });
    }

    setVideoElement = (element) => {
        const lightbox = document.querySelector('.lightbox')
        const container = lightbox.querySelector('.lb-container');

        const videoElement = this.createVideoElement(element);
        container.prepend(videoElement);
    }

    removeVideoElement = () => {
        const lightbox = document.querySelector('.lightbox')
        const container = lightbox.querySelector('.lb-container');
        const video = container.querySelector('video');

        if(video) {
            container.removeChild(video);
        }
    }

    createVideoElement = (element) => {
        const video = document.createElement('video');

        video.setAttribute('poster', element.href);
        video.setAttribute('controls', 'true');

        const source = document.createElement('source');
        source.setAttribute('src', element.dataset.href);
        source.setAttribute('type', 'video/mp4');

        video.append(source);

        return video;
    }

    findVideoLinks = () => {
        const hrefs = document.querySelectorAll('a.play-file-video[data-lightbox]');
        const regex = /\.(mp4|mov|flv|wmv)$/;
        if(0 === hrefs.length) {
            return [];
        }
        return Array.from(hrefs).filter((href) => {
            return !! href.dataset.href.match(regex);
        });
    }
}

(function () {
    'use strict';
    $(document).ready(function () {

        $(".play-youtube-video").modalVideo({
            channel: 'youtube'
        });

        $(".play-vimeo-video").modalVideo({
            channel: 'vimeo'
        });

        lightbox.option({
            'alwaysShowNavOnTouchDevices': true,
            'albumLabel': 'Zdjęcie %1 z %2',
        })
        new LightBoxVideo();

        // SOCIAL SHARING
        var $share = $('#share');
        $share.css('opacity', 1);
        $share.jsSocials({
            showLabel: false,
            showCount: false,
            shareIn: "popup",
            text: document.title,
            url: window.location.href,
            shares: [
                {
                    share: "facebook",
                    logo: `${$share.attr('data-templateURL')}/dist/images/facebook.svg`,
                    inlineSvg: true,
                },
                {
                    share: "twitter",
                    logo: `${$share.attr('data-templateURL')}/dist/images/twitter.svg`,
                    inlineSvg: true,
                    via: "pgnig",
                },
                {
                    share: "linkedin",
                    logo: `${$share.attr('data-templateURL')}/dist/images/linkedin.svg`,
                    inlineSvg: true,
                }
            ]
        });

        var $shareQuiz = $('#quiz-share');
        $shareQuiz.jsSocials({
            showLabel: false,
            showCount: false,
            shareIn: "popup",
            text: document.title,
            url: window.location.href,
            shares: [
                {
                    share: "facebook",
                    logo: `${$shareQuiz.attr('data-templateURL')}/dist/images/quiz-share.svg`,
                    inlineSvg: true,
                },
            ]
        });

        var swiperTexts = new Swiper('.swiper-texts-slider', {
            autoHeight: true,
            pagination: {
                el: '.swiper-pagination',
            },
            speed: 1000,
        });

        $('.subpage .swiper-gallery').each(function () {
            new Swiper($(this)[0], {
                slidesPerView: 4,
                spaceBetween: 30,
                navigation: {
                    prevEl: $(this).parent().find('.swiper-button-prev'),
                    nextEl: $(this).parent().find('.swiper-button-next'),
                },
                pagination: {
                    el: $(this).parent().find('.swiper-pagination'),
                    type: 'bullets',
                    clickable: true
                },
                breakpoints: {
                    1023: {
                        slidesPerView: 2
                    },
                    767: {
                        slidesPerView: 1
                    }
                }
            });
        });

        $('.subpage .swiper-video-gallery').each(function () {
            new Swiper($(this)[0], {
                slidesPerView: 3,
                spaceBetween: 30,
                navigation: {
                    prevEl: $(this).parent().find('.swiper-button-prev'),
                    nextEl: $(this).parent().find('.swiper-button-next'),
                },
                pagination: {
                    el: $(this).parent().find('.swiper-pagination'),
                    type: 'bullets',
                    clickable: true
                },
                breakpoints: {
                    1023: {
                        slidesPerView: 2
                    },
                    767: {
                        slidesPerView: 1
                    }
                }
            });
        });

        var swiperPages = new Swiper('.swiper-pages', {
            navigation: {
                nextEl: '.pages .swiper-button-next',
                prevEl: '.pages .swiper-button-prev',
            },
            spaceBetween: 30,
            slidesPerView: 3,
            speed: 1000,
            breakpoints: {
                1023: {
                    slidesPerView: 2
                },
                767: {
                    slidesPerView: 1
                }
            }
        });

        //QUIZ logic - start

        var swiperQuiz = new Swiper('.swiper-quiz', {
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
            },
            autoHeight: true,
            allowTouchMove: false,
            observer: true,
            observeParents: true,
        });


        $('.quiz .answer').on('click', function () {
            if (!$('.show-quiz-results').length) {
                $(this).addClass('selected').siblings().removeClass('selected');
                $(this).closest('.col-question').siblings('.col-buttons').find('.question-accept').attr('disabled', false);
            }
        });

        $('.question-clear').on('click', function () {
            $(this).parent().siblings('.col-question').find('.answer').removeClass('selected');
            $(this).siblings('.question-accept').attr('disabled', true);
        });

        $('.question-accept').on('click', function () {
            if (swiperQuiz.isEnd) {
                $('.col-buttons, .swiper-pagination').hide();
                $('.col-quiz').addClass('col-md-8');
                $('.col-question').removeClass('col-md-6');
                $('.col-image').hide();
                $('.swiper-quiz').addClass('show-quiz-results');
                var questionsCount = $('.question').length;
                var correctAnswersCount = $('.answer.correct.selected').length;
                $('.col-results .results-value').text(correctAnswersCount + '/' + questionsCount);
                $('.col-results').fadeIn();
                $("html, body").animate({
                    scrollTop: 0
                }, 500);
            } else {
                swiperQuiz.slideNext();
            }
        });

        //QUIZ logic - end

        //tools show/hide
        $('#tools-toggle').click(function () {
            $('.tools-list').animate({
                height: 'toggle'
            });
            $(this).toggleClass('opened');
        });

        // accordion scroll animation
        $('.subpage .accordion.scroll-animation .collapse, .subpage .accordion .collapse').on('shown.bs.collapse', function (e) {
            updateTableSize();
            var positionTop = $(this).parent().offset().top; // - $('header').height();
            $('html, body').animate({
                scrollTop: positionTop
            }, 500);
            $(window).resize();
        });

        // responsive image enlarging
        $('.popup-trigger').click(function (e) {
            $(this).parent().find('.popup-image-container').fadeIn();
            e.preventDefault();
            return false;
        });

        $('.popup-image-container').click(function () {
            $(this).fadeOut();
        });

        //Categories select
        $('.categories-select a').on('click', function(e) {
            e.preventDefault();
            $(this).toggleClass('selected');
            get_zoneposts('cat');
        });

        //Posts from categories loading by AJAX
        var page = 0; // What page we are on
        var ppp = 6; // Post per page
        //Load first "n" posts on page load
        function get_zoneposts(type) {
            var getType = type;
            if (getType === 'more') {
                page++;
            } else if (getType === 'cat') {
                page = 0;
            } else {
                page = 0;
            }

            if ($('.posts-container').length) {
                var cats = [];
                if (getType === 'more') {
                    if ($('.categories-select a.selected').length > 0) {
                        $('.categories-select a.selected').each(function() {
                            var catId = $(this).data('catid');
                            cats.push(catId);
                        });
                    } else {
                        $('.categories-select a').each(function() {
                            var catId = $(this).data('catid');
                            cats.push(catId);
                        });
                    }
                } else if (getType === 'cat') {
                    $('.categories-select a.selected').each(function() {
                        var catId = $(this).data('catid');
                        cats.push(catId);
                    });
                } else {
                    $('.categories-select a').each(function() {
                        var catId = $(this).data('catid');
                        cats.push(catId);
                    });
                }
                $.ajax({
                    url: "/wp-admin/admin-ajax.php",
                    method: "post",
                    timeout: 10000,
                    data: {
                        action: "get_zoneposts",
                        offset: page * ppp,
                        ppp: ppp,
                        categories: cats
                    },
                    success: function (data) {

                        if (getType === 'more') {
                            $('.posts-container').append(data);
                            if (data.length <= 0) {
                                $('#loading-end-posts').slideDown();
                            }
                        } else if (getType === 'cat') {
                            $('.posts-container').html(data);
                            $('#posts-load-more').slideDown();
                            if (data.length <= 0) {
                                $('#loading-no-posts').slideDown();
                            }
                        } else {
                            $('.posts-container').html(data);
                            if (data.length <= 0) {
                                $('#loading-no-posts').slideDown();
                            }
                        }

                        if (data.length <= 0) {
                            $('#posts-load-more').slideUp();
                        }
                    },
                    error: function () {
                        $('#loading-error').slideDown();
                    },
                    beforeSend: function () {
                        if (getType !== 'more') {
                            $('.posts-container').empty();
                        }
                        $('#loading-no-posts').slideUp();
                        $('#loading-end-posts').slideUp();
                        $('#loading-error').slideUp();
                        $('#loader').slideDown();
                    },
                    complete: function () {
                        $('#loader').slideUp();
                    },
                });
            }
        }

        get_zoneposts();

        //Load next "n" posts on button click
        $('#posts-load-more').click(function (e) {
            e.preventDefault();
            get_zoneposts('more');
        });

        //Form JS logic

        var submitting = false;
        function startSubmitting(form) {
            submitting = true;
            $(form).find('button[type=submit]').addClass('submitting');
        }
        function stopSubmitting(form) {
            submitting = false;
            $(form).find('button[type=submit]').removeClass('submitting');
        }

        //Bootstrap form validation
        window.addEventListener('load', function() {
            // Fetch all the forms we want to apply custom Bootstrap validation styles to
            var forms = document.getElementsByClassName('needs-validation');
            // Loop over them and prevent submission
            var validation = Array.prototype.filter.call(forms, function(form) {
                form.addEventListener('submit', function(event) {
                    if (form.checkValidity() === false) {
                        event.preventDefault();
                        event.stopPropagation();

                        form.classList.add('was-validated');
                        $('.form-sending-info').slideUp();
                    } else {
                        event.preventDefault();
                        form.classList.add('was-validated');

                        /// tutaj wysyłka i zapis do bazy

                        if (submitting) return;

                        $('.form-sending-info').slideUp();

                        var formData = new FormData(form);
                        formData.append('action', 'add_application');

                        startSubmitting(form);
                        $.ajax({
                            type: 'POST',
                            url: '/wp-admin/admin-ajax.php',
                            data: formData,
                            success: function (data) {
                                if(data.status === 'success') {
                                    $('.form-sending-info').text('Zgłoszenie zostało przesłane!').slideDown();
                                    form.reset();
                                    $('#contact-form').removeClass('was-validated');
                                } else {
                                    $('.form-sending-info').text('Nie udało się przesłać zgłoszenia!').slideDown();
                                }
                                stopSubmitting(form);
                            },
                            contentType: false,
                            processData: false
                        });

                        /// koniec - tutaj wysyłka i zapis do bazy
                    }

                }, false);
            });
        }, false);

        ///// File type validation

        function validateFileInput(file_id, mime_allowed){
            $("#" + file_id).change(function(){
                var fileInput = $("#" + file_id);
                if(mime_allowed.indexOf(document.getElementById(file_id).files[0].type) < 0){
                    $(fileInput).siblings('.invalid-feedback').text('Niedozwolony typ pliku! Wybierz plik .pdf, .doc lub .docx');
                    fileInput.replaceWith(fileInput.val('').clone(true));
                }
            });
        }

        validateFileInput("attachment", [
            'application/pdf',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        ]);

        ////////////////////////////////////////////////////////////////////////

        //Tooltipster

        // default tooltips
        $('.default-tooltipster').tooltipster({
            maxWidth: 290,
            contentAsHTML: true,
            interactive: true,
            functionPosition: function (instance, helper, position) {
                position.coord.left = helper.geo.origin.offset.left - 20;
                return position;
            },
        });

        function updateTableSize() {
            $('.table-container').each(function () {
                if ($(this).parent().hasClass('panel-body')) return;
                var containerWidth = $(this).width();
                var tableWidth = $('table', this).width();

                if (tableWidth > containerWidth) {
                    $(this).addClass('scrollable');
                    $(this).mCustomScrollbar({
                        axis: "x",
                        mouseWheel: {
                            enable: true
                        }
                    });
                } else {
                    $(this).removeClass('scrollable');
                    $(this).mCustomScrollbar('destroy');
                }
            });
        }

    });
}(jQuery));
